// in src/students.js
import React from 'react';
import { DateInput, FormDataConsumer, TopToolbar, ArrayInput, SimpleFormIterator, ArrayField, SingleFieldList, ChipField, List, Edit, Create, Datagrid, TextField, EditButton, LongTextInput, ReferenceInput, SelectInput, SimpleForm, TextInput, required, minLength, maxLength, minValue, maxValue, number, regex, email, choices, SelectField, AutocompleteInput } from 'react-admin';
import { RadioButtonGroupInput, useNotify, useRefresh, useRedirect, Filter, ListButton, CreateButton, ShowButton, DeleteButton, BulkDeleteButton } from 'react-admin';
import { Box, Typography, useMediaQuery } from '@material-ui/core';


export const CompleteCreate = (props) => {
    
    return (
        <Create title={<CompleteTitle />} {...props} >
                <Box p="1em">
                    <Box display="flex">
                        <Box >
                            <Typography variant="h6" gutterBottom>Your request has been received and will be processed. You will receive an update once we have processed your request. Thank you!!</Typography>
                        </Box>
                    </Box>
                </Box>
        </Create >
    );
};


const CompleteTitle = ({ record }) => {
    return <span>Thank you for your submission!!</span>;
};

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};


